module.exports = __webpack_public_path__ + "dict/img/info.5833660a.png";